import { RmxArrowBackIcon } from 'cokitchen-icons';
import FeedCard from 'components/feed-card';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { numberWithCommas } from 'utils/functions';
import { MealType } from 'utils/types';
import { ReactComponent as EditMealIcon } from 'assets/icons/edit-meal-icon.svg';
import { ReactComponent as DeleteMealIcon } from 'assets/icons/delete-meal-icon.svg';
import { ReactComponent as DuplicateMealIcon } from 'assets/icons/duplicate-meal-icon.svg';
import { ReactComponent as ConvertMealIcon } from 'assets/icons/convert-meal-icon.svg';
import MealDropdownOptions, { MealDropdownOptionType } from 'components/meal-dropdown-options';
import Select from 'components/base/select';
import { getBaseMeals } from 'pages/base-items/util';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const MealsByBase = () => {
  const [selectedBaseMeal, setSelectedBaseMeal] = useState('');
  const [baseMeals, setBaseMeals] = useState<MealType[]>();
  const [meals, setMeals] = useState<MealType[]>();
  const [loading, setLoading] = useState(false);
  const [activeMeal, setActiveMeal] = useState<MealType>();
  const [showDeleteMealModal, setshowDeleteMealModal] = useState(false);
  const { permissions, routePrefix } = useDashboardContext();

  const navigate = useNavigate();

  useEffect(() => {
    getMeals();
  }, [selectedBaseMeal]);

  const getMeals = async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`meal/base-meal/${selectedBaseMeal}`);
      setMeals(res.data.data.data);
    } catch {
      console.log('error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getBaseMeals(setBaseMeals, true);
  }, []);

  const deleteMeal = () => {
    setshowDeleteMealModal(!showDeleteMealModal);
  };
  const editMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/edit-meal/${activeMeal?.id}`);
  };
  const convertMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/convert-meal-to-addon/${activeMeal?.id}`, {
      state: activeMeal?.name
    });
  };
  const duplicateMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/duplicate-meal/${activeMeal?.id}`, {
      state: activeMeal?.name
    });
  };
  const dropdownList: MealDropdownOptionType[] = [
    {
      name: 'Edit meal',
      icon: <EditMealIcon className='w-4 h-4' />,
      onClick: editMeal
    },
    {
      name: 'Duplicate meal',
      icon: <DuplicateMealIcon className='w-4 h-4' />,
      onClick: duplicateMeal
    },
    {
      name: 'Convert meal',
      icon: <ConvertMealIcon className='w-4 h-4' />,
      onClick: convertMeal
    },
    {
      name: 'Archive meal',
      icon: <DeleteMealIcon className='w-4 h-4 text-red-5' />,
      className: 'text-red-5',
      onClick: deleteMeal
    }
  ];

  const canAccessMeals = permissions.canAccessMeals;
  if (!canAccessMeals) return <AccessDenied />;
  return (
    <div>
      <div className='w-[400px]'>
        <p className='mb-2'>Select base meal</p>
        <Select
          hasSearch
          value={selectedBaseMeal ?? ''}
          options={
            baseMeals?.map((item) => {
              return { value: item.id, text: item.name };
            }) || []
          }
          placeholder='Select base meal'
          onChange={(v) => setSelectedBaseMeal(v)}
          className='w-full'
          small
        />
      </div>
      {!selectedBaseMeal ? (
        <p className='text-sm flex justify-center items-center mt-7'>
          Select base meal to load meals
        </p>
      ) : loading ? (
        <p className='text-sm flex justify-center items-center mt-7'> loading ...</p>
      ) : meals?.length === 0 ? (
        <p className='text-sm flex justify-center items-center mt-7'>No meals found</p>
      ) : (
        <div className='grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-3 mt-4'>
          {meals?.map((meal) => (
            <div key={meal.id}>
              <FeedCard
                className='w-full'
                image={meal.images[0]}
                actions={
                  <MealDropdownOptions
                    onClick={() => setActiveMeal(meal)}
                    dropdownList={dropdownList}
                  />
                }>
                <Link to={`${routePrefix}/${ROUTE_KEYS.MEALS}/${meal.id}/addon-categories`}>
                  <div className='flex justify-between items-center mt-2'>
                    <div>
                      <p className='text-sm'>{meal?.base_meal?.name}</p>
                      <p className='text-xs text-gray-5'>&#8358;{numberWithCommas(meal.amount)}</p>
                    </div>
                    <RmxArrowBackIcon className='transform rotate-180 w-[20px] h-[20px] text-[#B6AFAF]' />
                  </div>
                </Link>
              </FeedCard>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MealsByBase;
